import React from "react";
import formatDate from "../../components/Control/formatDate";

const cellStyle = {
  border: "1px solid black",
  padding: "0.3rem",
};

const excelBorderProps = {
  "data-b-a-s": "thin",
  "data-b-a-c": "FF000000",
};

const SpecialProcessExcelTable = ({ data, process, headings }) => (
  <div aria-hidden="true" style={{ position: "fixed", left: "-10000px", top: 0 }}>
    <table
      id="special-process-excel-table"
      data-default-wrap="true"
      data-cols-width="8, 15, 18, 18, 15, 20, 20, 12, 18, 18, 20, 18, 24, 18"
      style={{ borderCollapse: "collapse" }}
    >
      <thead>
        <tr>
          <th
            colSpan={4}
            align="left"
            data-f-bold="true"
            data-a-v="middle"
            {...excelBorderProps}
            style={cellStyle}
          >
            Process No. : {process?.process_no}
          </th>
          <th
            colSpan={4}
            align="left"
            data-f-bold="true"
            data-a-v="middle"
            {...excelBorderProps}
            style={cellStyle}
          >
            Process Name : {process?.process_name}
          </th>
          <th
            colSpan={3}
            align="left"
            data-f-bold="true"
            data-a-v="middle"
            {...excelBorderProps}
            style={cellStyle}
          >
            Revision No. : {data.revision_no}
          </th>
          <th
            colSpan={3}
            align="left"
            data-f-bold="true"
            data-a-v="middle"
            {...excelBorderProps}
            style={cellStyle}
          >
            Revision Date : {formatDate(data.date_review)}
          </th>
        </tr>
        <tr data-height="8">
          <th colSpan={14} />
        </tr>
        <tr>
          {headings.map((heading) => (
            <th
              key={heading}
              data-fill-color="FF4472C4"
              data-f-color="FFFFFFFF"
              data-f-bold="true"
              data-a-v="middle"
              data-a-h="center"
              data-a-wrap="true"
              {...excelBorderProps}
              style={{
                ...cellStyle,
                backgroundColor: "#4472c4",
                color: "white",
              }}
            >
              {heading}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {process?.specs?.map((spec, index) => (
          <tr key={spec._id || index}>
            <td align="center" style={cellStyle}>{spec.s_no}</td>
            <td style={cellStyle}>{spec.machine}</td>
            <td style={cellStyle}>{spec.char_product}</td>
            <td style={cellStyle}>{spec.char_process}</td>
            <td align="center" style={cellStyle}>{spec.special_character}</td>
            <td style={cellStyle}>{spec.control_product}</td>
            <td style={cellStyle}>{spec.methods_measure}</td>
            <td align="center" style={cellStyle}>{spec.methods_size}</td>
            <td align="center" style={cellStyle}>{spec.methods_by}</td>
            <td align="center" style={cellStyle}>{spec.recording}</td>
            <td style={cellStyle}>{spec.methods_process}</td>
            <td style={cellStyle}>{spec.responsibility}</td>
            <td style={cellStyle}>{spec.reaction_plan}</td>
            <td style={cellStyle}>{spec.remarks}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SpecialProcessExcelTable;
